import { transition } from '@helpers/animate';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.div `
  @media ${from(Device.TabletLarge)} {
    &[data-mobile-only='true'] {
      display: contents;
    }
  }
`;
const Track = styled.ul `
  ${transition('transform')};

  display: flex;

  @media ${from(Device.DesktopSmall)} {
    [data-mobile-only='true'] & {
      display: contents;
    }
  }

  [data-vertical='true'] & {
    flex-direction: column;
  }
`;
const SimpleTrackStyles = {
    Container,
    Track,
};
export default SimpleTrackStyles;
